import sizes$1 from '../foundations/sizes.js';
var parts = ['container', 'excessLabel', 'badge', 'label'];
function baseStyleBadge(props) {
  var status = props.status;
  return {
    transform: 'translate(25%, 25%)',
    borderRadius: 'full',
    border: '0.16666666666em solid',
    borderColor: 'white',
    bg: function bg() {
      switch (status) {
        case 'online':
          return 'green.400';
        case 'offline':
          return 'gray.100';
        default:
          return null;
      }
    },
    boxSize: '0.9375em'
  };
}
function baseStyleExcessLabel() {
  return {
    bg: 'gray.100',
    color: 'gray.700'
  };
}
function baseStyleLabel() {
  return {
    fontFamily: 'body',
    fontWeight: 'bold'
  };
}
function baseStyleContainer() {
  return {
    bgGradient: 'linear(to-b, gray.300, gray.400)',
    color: 'white',
    borderColor: 'white',
    verticalAlign: 'top'
  };
}
var baseStyle = function baseStyle(props) {
  return {
    badge: baseStyleBadge(props),
    excessLabel: baseStyleExcessLabel(),
    label: baseStyleLabel(),
    container: baseStyleContainer()
  };
};
function getSize(size) {
  var themeSize = sizes$1[size];
  return {
    container: {
      width: size,
      height: size,
      fontSize: "calc(".concat(themeSize !== null && themeSize !== void 0 ? themeSize : size, " / 2.5)")
    },
    excessLabel: {
      width: size,
      height: size,
      fontSize: "calc(".concat(themeSize !== null && themeSize !== void 0 ? themeSize : size, " / 3)"),
      lineHeight: size !== '100%' ? themeSize !== null && themeSize !== void 0 ? themeSize : size : undefined
    },
    label: {
      fontSize: "calc(".concat(themeSize !== null && themeSize !== void 0 ? themeSize : size, " / 2.75)"),
      lineHeight: size !== '100%' ? themeSize !== null && themeSize !== void 0 ? themeSize : size : undefined
    }
  };
}
var sizes = {
  '2xs': getSize('4'),
  xs: getSize('6'),
  sm: getSize('8'),
  md: getSize('12'),
  lg: getSize('16'),
  xl: getSize('24'),
  '2xl': getSize('32'),
  full: getSize('100%')
};
var defaultProps = {
  size: 'lg'
};
var Avatar = {
  parts: parts,
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: defaultProps
};
export { Avatar as default };